export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-white mb-2">Politica de Privacidad</h1>
        <p className="text-sm text-zinc-500 mb-10">Ultima actualizacion: 12 de junio de 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Responsable del Tratamiento</h2>
            <p><strong>Titular:</strong> RAUL HORACIO OSTENGO</p>
            <p><strong>CUIT:</strong> 20-26638702-5</p>
            <p><strong>Domicilio:</strong> San Martin 839, Piso 3, Depto A - Entre calles Salta y Junin, San Miguel de Tucuman (4000), Tucuman, Argentina</p>
            <p><strong>Telefono:</strong> +54 9 381 414 9687</p>
            <p><strong>Sitio web:</strong> https://rcsender.com</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Datos que Recopilamos</h2>
            <p>Recopilamos la siguiente informacion cuando utilizas nuestros servicios:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Datos de cuenta:</strong> Nombre, correo electronico, foto de perfil (proporcionados via Google Auth).</li>
              <li><strong>Datos de uso:</strong> Campanas creadas, listas de contactos cargadas, plantillas de mensajes, registros de envio.</li>
              <li><strong>Datos tecnicos:</strong> Direccion IP, tipo de navegador, sistema operativo, datos de sesion.</li>
              <li><strong>Datos de contactos:</strong> Numeros de telefono y nombres de contactos que el usuario sube para sus campanas de mensajeria.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Finalidad del Tratamiento</h2>
            <p>Utilizamos los datos personales para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Proveer y operar la plataforma de mensajeria RCS y WhatsApp.</li>
              <li>Gestionar cuentas de usuario y autenticacion.</li>
              <li>Procesar y ejecutar campanas de envio de mensajes.</li>
              <li>Generar reportes y estadisticas de campanas.</li>
              <li>Mejorar la calidad del servicio y la experiencia del usuario.</li>
              <li>Cumplir con obligaciones legales y regulatorias.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Base Legal</h2>
            <p>El tratamiento de datos se fundamenta en:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>El consentimiento del usuario al registrarse y utilizar la plataforma.</li>
              <li>La ejecucion del contrato de servicio entre el usuario y RCS Sender.</li>
              <li>El cumplimiento de obligaciones legales aplicables.</li>
              <li>Ley 25.326 de Proteccion de Datos Personales de la Republica Argentina.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Comparticion de Datos</h2>
            <p>No vendemos ni compartimos datos personales con terceros, excepto:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Proveedores de infraestructura:</strong> Servicios de hosting y bases de datos necesarios para operar la plataforma.</li>
              <li><strong>Servicios de autenticacion:</strong> Google OAuth para el inicio de sesion.</li>
              <li><strong>Obligaciones legales:</strong> Cuando sea requerido por ley, orden judicial o autoridad competente.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Almacenamiento y Seguridad</h2>
            <p>Los datos se almacenan en servidores seguros con cifrado en transito (TLS/SSL) y en reposo. Implementamos medidas de seguridad tecnicas y organizativas para proteger la informacion contra acceso no autorizado, perdida o alteracion.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">7. Retencion de Datos</h2>
            <p>Conservamos los datos personales mientras la cuenta del usuario este activa o sea necesario para proveer los servicios. Los registros de envio se conservan por un periodo de 12 meses. El usuario puede solicitar la eliminacion de sus datos en cualquier momento.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">8. Derechos del Usuario</h2>
            <p>De acuerdo con la Ley 25.326, el usuario tiene derecho a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Acceso:</strong> Solicitar informacion sobre los datos personales tratados.</li>
              <li><strong>Rectificacion:</strong> Corregir datos inexactos o incompletos.</li>
              <li><strong>Supresion:</strong> Solicitar la eliminacion de datos personales.</li>
              <li><strong>Oposicion:</strong> Oponerse al tratamiento de datos en determinadas circunstancias.</li>
            </ul>
            <p className="mt-2">Para ejercer estos derechos, contactenos a: <strong>soporte@rcsender.com</strong></p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">9. Cookies y Tecnologias Similares</h2>
            <p>Utilizamos cookies estrictamente necesarias para el funcionamiento de la plataforma, incluyendo cookies de sesion y autenticacion. No utilizamos cookies de seguimiento publicitario.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">10. Cambios en esta Politica</h2>
            <p>Nos reservamos el derecho de modificar esta politica de privacidad en cualquier momento. Los cambios seran publicados en esta pagina con la fecha de actualizacion correspondiente.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">11. Contacto</h2>
            <p><strong>RAUL HORACIO OSTENGO</strong></p>
            <p>San Martin 839, Piso 3, Depto A - Entre calles Salta y Junin</p>
            <p>San Miguel de Tucuman (4000), Tucuman, Argentina</p>
            <p>CUIT: 20-26638702-5</p>
            <p>Telefono: +54 9 381 414 9687</p>
            <p>Email: soporte@rcsender.com</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-xs text-zinc-600">
          <p>&copy; {new Date().getFullYear()} RCS Sender — RAUL HORACIO OSTENGO. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
}
